import * as Sentry from "@sentry/react"
import { useQuery } from "@tanstack/react-query"

import { supabase } from "@/lib/supabase"

export type Depot = {
  id: string
  name: string
  depot_id: string
  address: string
  city: string
  valid_from: string
  valid_until: string | null
}

export const useDepots = () => {
  const { logger } = Sentry
  const sentryVerbose = import.meta.env.VITE_SENTRY_VERBOSE_UI === "true"

  return useQuery({
    queryKey: ["depots"],
    queryFn: async () =>
      Sentry.startSpan(
        {
          op: "db.query",
          name: "Fetch Depots",
        },
        async (span) => {
          try {
            const { data, error } = await supabase
              .from("depots")
              .select("id, name, depot_id, address, city, valid_from, valid_until")

            if (error) {
              Sentry.captureException(error)
              throw error
            }

            span.setAttribute("result_count", data?.length ?? 0)
            if (sentryVerbose) {
              logger.debug(logger.fmt`Fetched ${data?.length ?? 0} depots`)
            }

            return data || []
          } catch (err) {
            if (sentryVerbose) {
              logger.error("Failed to fetch depots", { err })
            }
            throw err
          }
        },
      ),
  })
}
